import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../util/axiosConfig"; // JWT 인터셉터 적용된 axios
import { useAuth } from "../../global/AuthContext"; // ✅ refreshUser 사용
import "../../assets/css/container/login/PrivacyConsentPage.css";
import {JOB_CATEGORY_LIST} from "../../global/globalProps";

export default function PrivacyConsentPage() {
	const navigate = useNavigate();
	const { refreshUser } = useAuth(); // ✅ 로그인 컨텍스트 갱신 함수

	// 상태
	const [region, setRegion] = useState("");
	const [job, setJob] = useState("");
	const [otherJob, setOtherJob] = useState("");
	const [consent, setConsent] = useState(false);
	const [loading, setLoading] = useState(false);

	const terms = `
FactWeb 개인정보 수집·이용 및 제3자 제공 동의서

FactWeb(이하 “회사”)은 회원가입 및 서비스 제공을 위하여 아래와 같이 개인정보를 수집·이용하며, 관련 법령에 따라 필요한 경우 제3자에게 제공할 수 있습니다.

1. 수집 항목
- 필수: 이메일, 닉네임, 이름, 성별, 연령대, 생년월일(또는 출생연도), 지역, 직업, 서비스 이용 기록(게시글, 댓글, 관심목록, 접속 로그, IP, 브라우저 정보 등)
- 선택: 연락처(휴대전화), 주소, 기타 회원이 자발적으로 제공한 정보

2. 수집 및 이용 목적
- 회원 가입 및 본인 확인
- 서비스 제공 및 운영(게시글, 댓글, 관심목록, 통계, 알림 등)
- 맞춤형 콘텐츠 제공 및 서비스 개선을 위한 통계·분석 활용
- 불법·부정 이용 방지 및 분쟁 해결, 법령 준수
- 가명·익명 처리 후 연구·학술 목적 활용

3. 보유 및 이용 기간
- 회원 탈퇴 시 즉시 파기
- 단, 관련 법령에 따라 일정 기간 보관 후 파기
  · 전자상거래법: 계약/청약철회 기록(5년), 대금결제/재화공급 기록(5년), 소비자 불만 및 분쟁 처리 기록(3년)
  · 통신비밀보호법: 접속 로그 기록(3개월)

4. 제3자 제공
- 제공받는 자: 연구기관, 학술단체, 협력사 등
- 제공 항목: 가명·익명 처리된 서비스 이용 데이터(게시글, 댓글, 관심정보, 통계자료 등)
- 제공 목적: 학술 연구, 서비스 품질 개선, 통계 분석
- 보유 및 이용 기간: 연구 또는 계약 목적 달성 시 즉시 파기

5. 동의 거부 권리 및 불이익
- 회원은 개인정보 수집·이용 및 제3자 제공에 대한 동의를 거부할 권리가 있습니다.
- 단, 필수 항목에 대한 동의를 거부할 경우 회원가입 및 서비스 이용이 불가합니다.

위 내용을 충분히 읽고 이해하신 후 동의 여부를 선택하시기 바랍니다.
`;

	const handleSubmit = async (e: any) => {
		e.preventDefault();

		if (!consent) {
			alert("개인정보 수집·이용에 동의해야 합니다.");
			return;
		}
		if (!region || !job) {
			alert("지역과 직업을 입력해주세요.");
			return;
		}

		try {
			setLoading(true);

			// 네이버 OAuth에서 받은 값 (localStorage 저장된 상태)
			const provider = localStorage.getItem("provider");
			const providerId = localStorage.getItem("providerId");
			const email = localStorage.getItem("email");
			const name = localStorage.getItem("name");
			const nickname = localStorage.getItem("nickname");
			const profileImage = localStorage.getItem("profile_image");
			const gender = localStorage.getItem("gender");
			const ageRange = localStorage.getItem("ageRange");
			const birthday = localStorage.getItem("birthday");
			const birthyear = localStorage.getItem("birthyear");
			const mobile = localStorage.getItem("mobile");
			const mobileE164 = localStorage.getItem("mobileE164");

			// PrivacyConsentPage 입력값
			const payload = {
				provider,
				providerId,
				email,
				name,
				nickname,
				profileImage,
				gender,
				ageRange,
				birthday,
				birthyear,
				mobile,
				mobileE164,
				region,
				job: job === "기타" ? otherJob : job, // 🔹 기타 선택 시 otherJob 사용
				privacyConsent: true,
			};

			// 🔹 회원가입 요청 (서버는 token도 함께 반환해야 함)
			const res = await axios.post("/api/user/signup", payload);
			const { token } = res.data;

			if (token) {
				localStorage.setItem("accessToken", token);
				await refreshUser(); // ✅ 로그인 상태 반영
				window.dispatchEvent(new Event("storage"));
			}

			alert("회원가입이 완료되었습니다.");
			navigate("/"); // 메인 페이지로 이동
		} catch (err) {
			console.error(err);
			alert("회원가입 중 오류가 발생했습니다.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="privacy-container">
			<h1 className="privacy-title">개인정보 활용 동의</h1>

			{/* 약관 스크롤 박스 */}
			<div className="privacy-terms-box">
				{terms}
			</div>

			<form onSubmit={handleSubmit} className="privacy-form">
				{/* 지역 선택 */}
				<div>
					<label className="privacy-label">지역</label>
					<select
						className="privacy-select"
						value={region}
						onChange={(e) => setRegion(e.target.value)}
					>
						<option value="">-- 선택하세요 --</option>
						<option value="서울">서울</option>
						<option value="경기">경기</option>
						<option value="부산">부산</option>
						<option value="전남">전남</option>
						<option value="전북">전북</option>
						<option value="충남">충남</option>
						<option value="충북">충북</option>
						<option value="강원">강원</option>
						<option value="제주">제주</option>
					</select>
				</div>

				{/* 직업 입력 */}
				<div>
					<label className="privacy-label">직업</label>
					<select
						className="privacy-input"
						value={job}
						onChange={(e) => setJob(e.target.value)}
					>
						<option value="">직업을 선택하세요</option>
						{JOB_CATEGORY_LIST.map((item, idx) => (
							<option key={idx} value={item}>
								{item}
							</option>
						))}
					</select>

					{/* 기타 선택 시 추가 입력창 */}
					{job === "기타" && (
						<input
							type="text"
							className="privacy-input"
							placeholder="직접 입력"
							value={otherJob}
							onChange={(e) => setOtherJob(e.target.value)}
						/>
					)}
				</div>

				{/* 동의 체크박스 */}
				<div className="privacy-checkbox">
					<input
						type="checkbox"
						checked={consent}
						onChange={(e) => setConsent(e.target.checked)}
					/>
					<span>개인정보 수집·이용 및 제3자 제공에 동의합니다.</span>
				</div>

				{/* 제출 버튼 */}
				<button
					type="submit"
					disabled={!consent || loading}
					className="privacy-button"
				>
					{loading ? "처리중..." : "회원가입 완료"}
				</button>
			</form>
		</div>
	);

}
